// ISOStandardsList.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';


const ISOStandardsList = () => {
    const [standards, setStandards] = useState([]);
    const [error, setError] = useState(null);

    const fetchStandards = async () => {
        try {
            // console.log("API Call for isocertifications");
            const response = await axios.get('/isocertifications');
            // console.log("API Response ",response);

            setStandards(response.data);
        } catch (error) {
            setError(error);
            console.error('Error fetching ISO standards:', error);
        }
    };

    useEffect(() => {
        fetchStandards();
    }, []);

    // const fetchStandards = useCallback(() => {
    //     const config = {
    //         url: "/mybooks",
    //         method: "get",
    //         headers: { Authorization: authState.token },
    //     };

    //     fetchData(config, { showSuccessToast: false })
    //         .then(response => {
    //             if (response && Array.isArray(response.mybooks)) {
    //                 setMyBooks(response.mybooks);
    //                 setNumberOfBooks(myBooks.length);
    //             } else {
    //                 console.error("Invalid response format: Book not found in response");
    //             }
    //         })
    //         .catch(error => {
    //             console.error("Error fetching MyBooks:", error);
    //         });
    // }, [authState.token, fetchData]);


    // useEffect(() => {
    //     if (!authState.isLoggedIn) return;
    //     fetchMyBooks();
    // }, [authState.isLoggedIn, fetchMyBooks]);

    // if (error) {
    //     return <div>Error fetching ISO standards: {error.message}</div>;
    //   }
    

    return (
        <MainLayout>
            <div>
                <h3 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>ISO Standards List</h3>
            </div>
            <div className="standards-list mt-2 w-7/12">
                <ul>
                    {standards.map((standard) => (
                        <li key={standard._id}>
                            <Link to={`/iso360-standarddetails/${standard._id}`}>
                                {standard.standardName} - {standard.standardTitle}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </MainLayout >
    );
};

export default ISOStandardsList;
